var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23906 0.852886L0.518535 8.57355C0.340128 8.75196 0.242188 8.98983 0.242188 9.24899C0.242188 9.50293 0.340128 9.74095 0.518535 9.91907L8.23173 17.6326C8.41028 17.811 8.6483 17.9092 8.90224 17.9092C9.15618 17.9092 9.39433 17.8111 9.57274 17.6326L10.1408 17.0645C10.3192 16.8861 10.4177 16.6479 10.4177 16.394C10.4177 16.1401 10.3192 15.902 10.1408 15.7235L3.66362 9.24631L10.1483 2.76195C10.3265 2.58354 10.4249 2.34553 10.4249 2.09144C10.4249 1.83751 10.3265 1.59963 10.1483 1.42108L9.57993 0.852886C9.21029 0.483391 8.6087 0.483391 8.23906 0.852886Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.90e83cca202642cf7a8604bd20478cdd.svg";
export { ForwardRef as ReactComponent };